import { prepareInvitationCommon, } from './prepare-invitation-common';
export const prepareGuestInvitation = async (params) => {
    const { invitation } = await prepareInvitationCommon(params);
    return invitation;
};
